<div class="modal-footer justify-content-between">
  <button type="button" class="btn-aux" [disabled]="cancelDisabled" (click)="onCancelClick.emit()">
    {{ cancelLabel }}
  </button>
  <button type="submit" class="btn-default" [disabled]="saveDisabled">
    {{ saveLabel }}
  </button>
</div>